import employeeService from "services/employee-service";

const defaultProvider = {
  id: null,
  firstName: null,
  lastName: null,
  physicianNPI: null,
  state: null,
};

const state = {
  provider: defaultProvider
};

const actions = {
  async createEditProvider({ commit }, provider) {
    provider.id
      ? await employeeService.updateProvider(provider)
      : await employeeService.createProvider(provider);

    commit('provider-saved');
  },

  async loadProvider({ commit }, id) {
    const provider = id
      ? await employeeService.getByEmployeeId(id)
      : { ...defaultProvider };

    commit('provider-loaded', provider);
  },
};

const mutations = {
  'provider-loaded'(state, provider) {
    state.provider = provider;
  },

  'provider-saved'() {

  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
}